import { render, staticRenderFns } from "./OOctagon.vue?vue&type=template&id=2a02638b&scoped=true"
import script from "./OOctagon.vue?vue&type=script&lang=js"
export * from "./OOctagon.vue?vue&type=script&lang=js"
import style0 from "./OOctagon.vue?vue&type=style&index=0&id=2a02638b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a02638b",
  null
  
)

export default component.exports